import {Component, ComponentOptions, PartOptions, LayoutOptions} from "@mecatran-components/component";
import {Input} from "@mecatran-components/input";


export class SearchBox extends Component{
    constructor(searchBoxOptions){
        var searchBoxOptions = searchBoxOptions || {};
        var componentOptions = new ComponentOptions();
        componentOptions.setDomOptions(searchBoxOptions.domOptions);
        componentOptions.setContext(searchBoxOptions);
        super(componentOptions);

        this.initSearchBox(searchBoxOptions)
    }

    // =======
    // private
    // -------
    getSearch(){ 
        return this.getStorageManager().getComponents('search')[0];
    }

    
    isClearButton(element){
        return (element.tagName === 'INPUT' && element.id === 'clear') 
    }

    onClearButtonClick(event){
        var search = this.getSearch();
        search.setValue('');
        this.emitCustomEvent('clearEvent')
    }

    createLabelNode(label){
        var node = document.createElement('span');
        node.innerHTML = label;
        return node;
    }


    initSearchBox(searchBoxOptions){
        var searchBoxOptions = searchBoxOptions || {};

        /* search input */ 
        var inputOptions = searchBoxOptions.inputOptions || {};
        inputOptions.id = "cherche";
        var input = new Input(inputOptions);
        this.addSubComponent(input,'search');

        var clearButton = new Input({ 
            src  : searchBoxOptions.clearButtonUrl || './cross.svg',
            classList :  ['clear'],
            style : { 'vertical-align': 'middle'},
            id : 'clear'
        });
        this.addSubComponent(clearButton,'clear');
        
        this.build();
    }


    // ==========
    // overloaded
    // ----------
    createContainerNode(domOptions){
        var context = context || {};
        console.log('createContainerNode',context)
        var div = document.createElement('div');
        SearchBox.setDomOptions(div,domOptions)
        console.log(div)
        return div;
    }

    createContentNode(context){ 
        console.log('createContentNode', context)
        var label = (context) ? context.label : undefined;
        if (label) return this.createLabelNode(label);
        else return;
     }

    defineEventListeners(eventManager){
        //eventManager.on('inputEvent', this.isSearchInput, this.onSearchInputInput.bind(this), false );
        eventManager.on('click', this.isClearButton, this.onClearButtonClick.bind(this), true);
    };

    // ==========
    // public 
    // ----------
    setValue(value){
        var search = this.getSearch();
        search.setValue(value);
    }

    getValue(){
        return this.getSearch().getValue();
    }

    // ==========
    // static
    // ----------
    static setDomOptions(node, domOptions){
        var domOptions = domOptions || {};
        if (domOptions.style){
            var strStyle = OriginDestination.serializeObject(domOptions.style); 
            node.setAttribute('style',strStyle)
        }
        if (domOptions.classList) domOptions.classList.forEach(className => node.classList.add(className));
        if (domOptions.id) node.setAttribute('id',domOptions.id);
    }

    static serializeObject(object){
        var str = '';
        Object.entries(object).forEach(([k,v])=> str+= `${k}:${v}`)
        return str;
    }
    
}


/**
 * inputOptions : InputOptions (optional)
 * clearButtonUrl : url on image 
 * label 
 * 
 * domOptions
 */
class SearchBoxOptions{}